module.exports = __webpack_public_path__ + "e3f2b3822713728d56d3739f31efb3eb.png";